import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { BinderService } from '../api/binder.service';
import { ApprovalsService } from '../api/approvals.service';
import { ApprovalState } from '@/models/approval.model';
import { UserData } from '@/models/user-data.model';
import { BinderAccess } from '@/models/binder-access.model';
import { AppAuthService } from './auth.service';
import { CategoriesService } from '../api/categories.service';

@Injectable({
  providedIn: 'root'
})
export class UserAccessService {
  authService = inject(AppAuthService);
  currentApprovalRequestService = inject(ApprovalsService);
  binderService = inject(BinderService);
  categoriesService = inject(CategoriesService);

  binderEditAccess = signal(false);
  binderAssembliesEditAccess = signal(false);
  binderPlanPriceAccess = signal(false);
  foundersRestrictedAccess = signal(false);
  approvalAccess = signal(false);

  foundersCategoryIds: number[]=[322, 321]

  constructor(

  ) {
    effect(() => {
      const approval = this.currentApprovalRequestService.approvalState();
      const binder = this.binderService.currentBinder();
      const editAccess = this.binderService.apiEditAccess();
      const userPerms = this.authService.userPerms();
      if(approval) {
        const locked = this.checkApprovalLock(approval);
        this.setBinderEditAccess(!locked);
        this.setBinderAssembliesEditAccess(!locked);
      } 
      if(binder) {
        this.setStatusLock(binder.ProjectStatus);
      }

      if(userPerms && binder) {
        // console.log('checking binder price access', binder.SelectedFID, binder.Plans.customPlan);
        const permaccess = this.authService.checkForPerm('binder', 'price', binder.SelectedFID) || binder.Plans.customPlan;
        if(permaccess) {
          this.binderPlanPriceAccess.set(true);
        } else {
          this.binderPlanPriceAccess.set(false);
        }

      }
      if(binder && binder.Plans.Collection==='Founders') {
        this.setFoundersRestrictedAccess(true);
      } else {
        this.setFoundersRestrictedAccess(false);
      }
    });
   }

  setBinderEditAccess(access: boolean) {
    // console.log('setting binder edit access', access);
      this.binderEditAccess.set(access);
  } 

  checkApprovalLock(approval?: ApprovalState) {
    if(approval) {
    const locked = approval === 'signing' || approval === 'drafting' || approval === 'approved' || approval === 'pending';
    // console.log('approval lock', locked);
      return locked;
    }
    return false;
  }

  foundersCategories = computed(() => {
    if(this.foundersRestrictedAccess()) {
      return this.categoriesService.categories().filter(c => this.foundersCategoryIds.includes(c.CategoryID));
    }
    return this.categoriesService.categories();
  });

  setStatusLock(status: number) {
    const editAccess = this.binderService.apiEditAccess();
    const locked = status > 3;
    // console.log('status lock', locked);
    this.binderEditAccess.set(!locked && editAccess);
    this.binderAssembliesEditAccess.set(!locked && editAccess);
  }

  setBinderAssembliesEditAccess(access: boolean) {
    // console.log('setting binder assemblies edit access', access);
    const locked = this.checkApprovalLock(this.currentApprovalRequestService.approvalState());
    // console.log('locked', locked);
    if(access && !locked) {
      // console.log('setting binder assemblies edit access to true');
      this.binderAssembliesEditAccess.set(access);
    } else {
      // console.log('setting binder assemblies edit access to false');
      this.binderAssembliesEditAccess.set(false);
    }
  }

  setBinderPlanPriceAccess(access: boolean) {
    this.binderPlanPriceAccess.set(access);
  }

  setFoundersRestrictedAccess(access: boolean) {
    this.foundersRestrictedAccess.set(access);
  }

  updateAccess(access: boolean) {
    this.approvalAccess.set(access);
  }

  setApprovalAccess(profile: UserData, fid: number) {
    const hasAccess = profile.UserRoles?.some(userRole =>
      userRole.PermRoles?.RoleAccess?.some(roleAccess =>
        roleAccess.AccessPermissions.dataTable === 'approvalResponses' &&  (roleAccess.AccessPermissions.FID === fid || roleAccess.AccessPermissions.FID === null)
      )
    ) || false;
    this.updateAccess(hasAccess)
  }
  
}
